<template>
	<div>
		<!-- 内容信息 -->
		<bullehead title="内容信息"></bullehead>
	
		<div class="cinforbox FlexBox"  v-if="detail">
			<div class="img_boxe FlexRow"> 
				
				<el-image :src="detail.portrait" v-if="detail.portrait" >
				</el-image>
				<el-image :src="headurl + detail.icon" v-else-if="detail.icon">
				</el-image>
				<el-image :src="detail.file_url" v-else-if="detail.file_url">
				</el-image>
				
				
			</div>
			<div class="infos FlexBox FlexDirColumn FlexJusBetween">
				<div class="title Flexalign">
					<div class="icon FlexRow">
						<el-image :src="headurl + detail.icon" v-if="detail.icon" >
							<div slot="error" class="image-slot">
								<i class="el-icon-warning" ></i>
							</div>
						</el-image>
						<el-image :src="detail.file_url" v-else >
							<div slot="error" class="image-slot">
								<i class="el-icon-warning" ></i>
							</div>
						</el-image>
					</div>
					<div class="tit">
						{{detail.name || ''}}
					</div>
				</div>
				<div class="otherbox">
					<div class="txt" v-if="detail.member_name">
						分享人：{{detail.member_name || ''}}
					</div>
					<div class="txt" v-if="detail.start_time">
						分享时间：{{detail.start_time || ''}}
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import bullehead from "../../bulletinboard/components/bullehead.vue"
	export default {
		components: {
			bullehead,
		},
		props: {
			detail: {
				type: Object,
				default: ()=>{
					return {}
				},
			},
		},
		data() {
			return {
				headurl: 'https://scrm.51kuaiding.com/scrm/hktxcx/briefing',
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../css/report.scss";
	
</style>